import styled from "styled-components";
import { Box as MuiBox, Typography as MuiTypography } from "@mui/material";

import { Wrap as TemplatesWrap } from "../Templates/styles";

// 필터 다이얼로그 행 / 요약 줄 컨테이너는 다른 리스트 페이지와 같은 것을 쓴다.
export { Box, SecondBox } from "../Templates/styles";
export { SecondContainer, ThirdBox } from "../AIReview/styles";

/**
 * 페이지 컨테이너. 공용 Wrap(고정 폭)에 아래 여백을 더한다 — 표와 그리드 푸터가
 * 컨테이너 끝에 딱 붙어 답답해 보이지 않게 한다.
 */
export const Wrap = styled(TemplatesWrap)`
  &.MuiBox-root {
    padding-bottom: 64px;
  }
`;

/** 인기 키워드 표 아래 여백. 마지막 행과 페이지 끝 사이를 띄운다. */
export const TableFooterSpace = styled(MuiBox)`
  &.MuiBox-root {
    height: 32px;
  }
`;

export const Typography = styled(MuiTypography)`
  &.MuiTypography-root {
    /* flex-direction / justify-content 는 두지 않는다 (Page Module Pattern 참고). */
    font-size: 14px;
    text-overflow: ellipsis;
  }
`;

/** 인기 키워드 결과 위에 붙는 집계 요약 줄 */
export const SummaryBar = styled(MuiBox)`
  &.MuiBox-root {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 24px;
    padding: 8px 12px;
    margin-bottom: 8px;
    border-radius: 8px;
    background: rgba(103, 80, 164, 0.06);
    color: #49454f;
    font-size: 13px;
  }
  & strong {
    color: #1c1b1f;
    font-weight: 600;
  }
`;

/**
 * 키워드 행 아래로 펼쳐지는 대표 템플릿 가로 목록.
 * GlobalStyles 가 모든 요소의 스크롤바를 숨기므로(`* ::-webkit-scrollbar {display:none}`)
 * 가로로 넘치는 이 목록은 스크롤바를 직접 살려야 마우스 사용자도 넘길 수 있다.
 * 색은 AppContainer 의 세로 스크롤바와 맞춘다.
 */
export const TemplateStrip = styled(MuiBox)`
  &.MuiBox-root {
    display: flex;
    gap: 12px;
    overflow-x: auto;
    padding: 8px 4px 12px;
    /* GlobalStyles 의 "* { scrollbar-width: none }" 을 되돌린다 (auto 만; thin 이나
       scrollbar-color 를 주면 Chrome 이 ::-webkit-scrollbar 를 무시한다). */
    scrollbar-width: auto;
  }
  &.MuiBox-root::-webkit-scrollbar {
    display: block;
    height: 8px;
  }
  &.MuiBox-root::-webkit-scrollbar-thumb {
    background-color: rgba(103, 80, 164, 0.6);
    border-radius: 4px;
  }
  &.MuiBox-root::-webkit-scrollbar-thumb:hover {
    background-color: rgba(103, 80, 164, 0.8);
  }
  &.MuiBox-root::-webkit-scrollbar-track {
    background: rgba(103, 80, 164, 0.06);
    border-radius: 4px;
  }
`;

export const TemplateCard = styled(MuiBox)`
  &.MuiBox-root {
    flex: 0 0 auto;
    width: 150px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    cursor: pointer;
    border-radius: 6px;
    padding: 6px;
    border: 1px solid rgba(33, 33, 33, 0.08);
    background: #fff;
  }
  &.MuiBox-root:hover {
    border-color: #6750a4;
  }
`;

export const CardMeta = styled(MuiTypography)`
  &.MuiTypography-root {
    font-size: 11px;
    line-height: 16px;
    color: #49454f;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

/** templateCount / scannedTemplates 비율 막대 */
export const RatioBar = styled.div<{ ratio: number }>`
  position: relative;
  height: 6px;
  width: 120px;
  border-radius: 3px;
  background: rgba(103, 80, 164, 0.12);
  overflow: hidden;
  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: ${({ ratio }) => Math.max(0, Math.min(100, ratio * 100))}%;
    background: #6750a4;
  }
`;
